import React from "react";
import "../index.css";

import { useLandingPage } from "../context/LandingPageContext";
import { defaultStories } from "../constants/constants";



const QuoteIcon = () => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="stories-quote-icon"
  >
    <path
      d="M0 13.5V8.5C0 5.83333 0.583333 3.625 1.75 1.875C2.91667 0.125 4.63333 -0.416667 6.9 0.25L6.5 2.85C5.36667 2.68333 4.45833 3.05833 3.775 3.975C3.09167 4.89167 2.75 6.18333 2.75 7.85H6.5V13.5H0ZM11.5 13.5V8.5C11.5 5.83333 12.0833 3.625 13.25 1.875C14.4167 0.125 16.1333 -0.416667 18.4 0.25L18 2.85C16.8667 2.68333 15.9583 3.05833 15.275 3.975C14.5917 4.89167 14.25 6.18333 14.25 7.85H18V13.5H11.5Z"
      fill="currentColor"
    />
  </svg>
);

const StoriesSection = () => {
  const { landingData } = useLandingPage();

  const stories =
    landingData?.stories && landingData.stories.length > 0
      ? landingData.stories
      : defaultStories;

  return (
    <section id="stories" className="stories-section">
      <h2 className="stories-title">The Stories</h2>

      <div className="stories-grid">
        {stories.map((story) => (
          <div key={story.id} className="stories-card">
            <QuoteIcon />

            <p className="stories-quote">{story.message}</p>

            <div className="stories-author">
              <img
                src={story.photoUrl}
                alt={story.reviewerName}
                className="stories-avatar"
              />

              <div className="stories-author-info">
                <span className="stories-name">{story.reviewerName}</span>

                <span className="stories-role">{story.occupation}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StoriesSection;